var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DESIGNER_SETTINGS } from '../../core/settings/designer/designer-settings';
var DesignerSettingsServiceImpl = /** @class */ (function () {
    function DesignerSettingsServiceImpl(designerSettings) {
        this.designerSettings = designerSettings;
        this.isShowGridChange = new BehaviorSubject(designerSettings.isShowGrid);
        this.isGridSnapEnabledChange = new BehaviorSubject(designerSettings.isGridSnapEnabled);
        this.isGuidelineSnapEnabledChange = new BehaviorSubject(designerSettings.isGuidelineSnapEnabled);
    }
    Object.defineProperty(DesignerSettingsServiceImpl.prototype, "isShowGrid", {
        get: function () {
            return this.designerSettings.isShowGrid;
        },
        set: function (value) {
            if (this.designerSettings.isShowGrid !== value) {
                this.designerSettings.isShowGrid = value;
                this.isShowGridChange.next(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesignerSettingsServiceImpl.prototype, "isGridSnapEnabled", {
        get: function () {
            return this.designerSettings.isGridSnapEnabled;
        },
        set: function (value) {
            if (this.designerSettings.isGridSnapEnabled !== value) {
                this.designerSettings.isGridSnapEnabled = value;
                this.isGridSnapEnabledChange.next(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesignerSettingsServiceImpl.prototype, "isGuidelineSnapEnabled", {
        get: function () {
            return this.designerSettings.isGuidelineSnapEnabled;
        },
        set: function (value) {
            if (this.designerSettings.isGuidelineSnapEnabled !== value) {
                this.designerSettings.isGuidelineSnapEnabled = value;
                this.isGuidelineSnapEnabledChange.next(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    DesignerSettingsServiceImpl = __decorate([
        Injectable(),
        __param(0, Inject(DESIGNER_SETTINGS))
    ], DesignerSettingsServiceImpl);
    return DesignerSettingsServiceImpl;
}());
export { DesignerSettingsServiceImpl };
